// import {BRANCHES} from '../assets/constant';
import { DELIVERY_THRESHOLD } from '../config';
// import moment from 'moment';
export default {
    our_store: ["ร้านค้า", "Our Store"],
    track_order: ["ติดตามสินค้า", "Track Order"],
    upload_receipt: ["แจ้งชำระเงิน", "Upload Receipt"],
    login: ["เข้าสู่ระบบ", "Log in"],
    signup: ["สมัครสมาชิก", "Sign up"],
    profile: ["ข้อมูลส่วนตัว", "Profile"],
    CLICK_HERE: ["คลิกที่นี่", "Click Here"],
    HI: ["สวัสดีค่ะ", "HI, "],
    SIGN_OUT: ["ออกจากระบบ", "Sign out"],
    TRACKING_ORDER: [`ติดตามสินค้า`, `Order Tracking`],
    CONFIRM_PAYMENT: [`แจ้งการชำระเงิน`, `Confirm Payment`],
    JOIN_PARTNER: [`นำเสนอสินค้า`, `Sell on BEAUTRIUM`],
    FAQ: [`คำถามพบบ่อย`, `FAQ`],
    LOGIN: [`เข้าสู่ระบบ`, `Login`],
    SIGN_UP: [`สมัครสมาชิก`, `Sign up`],
    SHOPPING_CART: [`รถเข็นสินค้า`, `Shopping Cart`],
    SHOP_CATEGORY: [`ร้านค้า`, `Shop`],
    NEW_IN: [`สินค้ามาใหม่`, `New Arrivals`],
    BEST_SELL: [`สินค้าขายดี`, `Best Sellers`],
    BRANDS: [`แบรนด์ทั้งหมด`, `Brands`],
    PROMO: [`ดีลพิเศษ`, `Deals`],
    BLOGS: [`คอมมูนิตี้`, `Community`],
    CAMPAIGN: {
        GIVEAWAY: [`แจกฟรีแลกรีวิว`, `Free For Review`]
    },
    REVIEW: [`รีวิวสินค้า`, `Review`],
    CAREER: [`ร่วมงานกับเรา`, `Careers`],
    ABOUT_US: [`เกี่ยวกับเรา`, `About BEAUTRIUM`],
    SEARCH_BUTTON: [`ค้นหา`, `Search`],
    SEARCH_BAR: [`ค้นหาสินค้า`, `Search`],
    ACCT_MY_ACCOUNT: [`บัญชีของฉัน`, `My Account`],
    ACCT_MY_INFO: [`ข้อมูลส่วนตัว`, `Account Information`],
    ACCT_MY_ORDERS: [`ประวัติรายการสั่งซื้อ`, `My Orders`],
    ACCT_MY_FAVORITE: [`รายการสินค้าที่สนใจ`, `My Wishlist`],
    ACCT_MY_MISSION: [`สมุดภารกิจ`, `My Mission`],
    ACCT_MY_ADDRESS: [`สมุดบันทึกที่อยู่`, `Address Book`],
    ACCT_MY_COUPON: [`คูปอง`, `My Coupon`],
    ACCT_REWARD_POINT: [`คะแนนสะสม`, `BEAUTRIUM Coins`],
    ACCT_INVITE: [`ชวนเพื่อน`, `Invite Friends`],
    ACCT_NOTIFICATION: [`ตั้งค่าการแจ้งเตือน`, `Notification Setting`],
    ACCT_DELETE: [`ลบผู้ใช้งาน`, `Account Delete`],
    ACCT_CHANGE_PASSWORD: [`เปลี่ยนรหัสผ่าน`, `Change Password`],
    CALL_ACT_KINGDOM: [`แบรนด์ดัง\nจากทุก\nมุมโลก`, `Brands From\nAll Around\nThe World`],
    CALL_ACT_FREE_SHIPPING: [`ส่งฟรี!\nเมื่อซื้อครบ\n${DELIVERY_THRESHOLD} บาท`, `Free Shipping!\nFor orders\n฿${DELIVERY_THRESHOLD} & Above`],
    CALL_ACT_CASH_ON: [`บริการ\nเก็บเงิน\nปลายทาง`, `Cash On\nDelivery`],
    CALL_ACT_GUARANTEE: [`รับประกัน\nของแท้\n100%`, `100% Genuine\nGuaruntee`],
    CALL_ACT_UPDATE_PROMO: [`โปรโมชั่นใหม่\nทุกสัปดาห์`, `Weekly New & Surprising Promotions`],
    CALL_ACT_BT_COIN: [`สะสม\nคะแนน ใน\nทุกการซื้อ`, `Get coins\nfor every\ncompleted orders.`],
    CALL_ACT_BRANCHES: [`มีสาขาทั่ว\nกทม. และ\nต่างจังหวัด`, `Many branches\nin Bangkok and Upcountry`],
    CATE_CATEGORY: [`ประเภทสินค้า`, `Categories`],
    CATE_MAKEUP: [`เครื่องสำอาง`, `Make Up`],
    CATE_SKINCARE: [`สกินแคร์`, `Facial Skincare`],
    CATE_HAIR: [`ผลิตภัณฑ์ดูแลเส้นผม`, `Hair`],
    CATE_ACCESSORY: [`อุปกรณ์เสริม`, `Accessory`],
    CATE_BATHBODY: [`ผลิตภัณฑ์ดูแลผิวกาย`, `Bath & Body`],
    CATE_FRAGRANCE: [`น้ำหอม`, `Fragrance`],
    CATE_SUPPLEMENT: [`อาหารเสริม`, `Supplement`],
    CATE_MEN: [`สำหรับผู้ชาย`, `Men`],
    CATE_EYEPERSONALCARE: [`ดูแลดวงตา & ของใช้ส่วนตัว`, `Eye & Personal Care`],
    CATE_DERMA: [`เวชสำอางค์`, `Derma`],
    MAKEUP_FACE: [`หน้า`, `Face`],
    MAKEUP_PRIMER: [`เบสและไพรเมอร์`, `Base & Face Primer`],
    MAKEUP_FOUNDATION: [`รองพื้น`, `Foundation`],
    MAKEUP_BBCC_CREAM: [`บีบีและซีซีครีม`, `BB & CC Cream`],
    MAKEUP_CONCEALER: [`คอนซีลเลอร์และคอเรคเตอร์`, `Concealer & Corrector`],
    MAKEUP_POWDER: [`แป้งและคุชชั่น`, `Powder & Cushion`],
    MAKEUP_BLUSH: [`บลัช`, `Blush`],
    MAKEUP_CONTOUR: [`คอนทัวร์และบรอนเซอร์`, `Contour & Bronzer`],
    MAKEUP_HIGHLIGHT: [`ไฮไลท์`, `Highlighter & Illuminator`],
    MAKEUP_FINISH_SPRAY: [`เซ็ตติ้งและฟินิชชิ่งสเปรย์`, `Setting & Finishing Spray`],
    MAKEUP_PALETTE_SET: [`พาเลทและเซ็ตเมคอัพ`, `Face Palettes & Sets`],
    MAKEUP_EYE: [`ตกแต่งดวงตา`, `Eyes`],
    MAKEUP_EYEPRIMER: [`อายไพรเมอร์และเบส`, `Eye Primer & Base`],
    MAKEUP_EYESHADOW: [`อายแชโดว์`, `Eyeshadow`],
    MAKEUP_EYELINER: [`อายไลเนอร์`, `Eyeliner`],
    MAKEUP_MASCARA: [`มาสคาร่า`, `Mascara`],
    MAKEUP_EYEBROW: [`ดินสอเขียนคิ้ว`, `Eyebrows`],
    MAKEUP_EYE_PALETTE: [`พาเลทและเซ็ตแต่งตา`, `Eye Palettes & Sets`],
    MAKEUP_LIP: [`ตกแต่งริมฝีปาก`, `Lips`],
    MAKEUP_LIP_PRIMER: [`ลิปไพรเมอร์และฟินิชเชอร์`, `Lip Primer & Finisher`],
    MAKEUP_LIP_CARE: [`ลิปแคร์`, `Lip Care`],
    MAKEUP_LIP_TINT: [`ลิปสเตนและทินท์`, `Lip Stain & Tint`],
    MAKEUP_LIP_COLOR: [`ลิปสติก`, `Lip Color`],
    MAKEUP_LIP_GLOSS: [`ลิปกลอสและลิปพรัมเปอร์`, `Lip Gloss & Lip Plumper`],
    MAKEUP_LIP_LINER: [`ลิปไลเนอร์`, `Lip Liner`],
    MAKEUP_LIP_PALETTE: [`พาเลทและลิปเซ็ต`, `Lip Palettes & Set`],
    SKINCARE_MASK_TREATMENT: [`มาส์กและทรีทเม้นท์`, `Mask & Treatments`],
    SKINCARE_ACNE: [`รักษาสิว`, `Acne & Pore`],
    SKINCARE_MASKSHEET: [`มาสก์แผ่น`, `Mask Sheet`],
    SKINCARE_MASKCREAM: [`มาสก์ครีม`, `Mask Cream`],
    SKINCARE_EYE_LASHCARE: [`รอบดวงตาและบำรุงขนตา`, `Eye & Lash Care`],
    SKINCARE_LIP_CARE: [`บำรุงริมฝีปาก`, `Lip Care`],
    SKINCARE_MAKEUP_REMOVER: [`ล้างเครื่องสำอาง`, `Makeup Remover`],
    SKINCARE_FACE_MAKEUP_REMOVER: [`ล้างเครื่องสำอางสำหรับใบหน้า`, `Face Makeup Remover`],
    SKINCARE_EYELIP_MAKEUP_REMOVER: [`ล้างเครื่องสำอางสำหรับดวงตาและริมฝีปาก`, `Eyes & Lips Makeup Remover`],
    SKINCARE_CLEANSER: [`ผลิตภัณฑ์ทำความสะอาดและผลัดเซลล์ผิว`, `Cleanser & Exfoliator`],
    SKINCARE_BLOTTING_PAPER: [`กระดาษซับมัน`, `Blotting Paper`],
    SKINCARE_SCRUB_EXFOLIATOR: [`ลอกหน้า & สครับ & ผลิตภัณฑ์ผลัดเซลล์ผิว`, `Peel & Scrub & Exfoliator`],
    SKINCARE_FACIAL_CLEANSER: [`ผลิตภัณฑ์ทำความสะอาดผิวหน้า`, `Facial Cleanser`],
    SUN_CARE: [`ผลิตภัณฑ์ปกป้องผิวจากแสงแดด`, `Sun Care`],
    FACE_SUNSCREEN: [`ครีมกันแดดสำหรับผิวหน้า`, `Face Sunscreen`],
    AFTER_SUN: [`ผลิตภัณฑ์บำรุงผิวหลังออกแดด`, `After Sun Care`],
    MOISTURISER: [`มอยเจอร์ไรเซอร์`, `Moisturiser`],
    SKINCARE_FACIALMIST: [`สเปรย์บำรุงผิวหน้า`, `Facial Mist`],
    SKINCARE_NIGHTCREAM: [`มอยเจอร์ไรเซอร์สำหรับกลางคืน`, `Night Cream`],
    SKINCARE_FACE_CREAM: [`ครีมบำรุงผิวหน้าและมอยเจอร์ไรเซอร์`, `Face Cream & Moisturiser`],
    SKINCARE_SERUM_BOOSTER: [`เซรั่มและบูสเตอร์`, `Serum & Booster`],
    SKINCARE_SET_HEADER: [`เซ็ตสกินแคร์`, `Skincare Sets`],
    SKINCARE_TONER: [`โทนเนอร์`, `Toner`],
    STYLING: [`ผลิตภัณฑ์จัดแต่งทรงผม`, `Styling`],
    HAIR_STYLING: [`จัดแต่งทรงผม`, `Hair Styling`],
    HAIR_SHAMPOO_CON: [`แชมพูและครีมนวดผม`, `Shampoo & Conditioner`],
    HAIR_LEAVEIN_CONDITIONER: [`ครีมนวดผมชนิดไม่ต้องล้างออก`, `Leave-In Conditioner`],
    HAIR_CONDITIONER: [`ครีมนวดผม`, `Conditioner`],
    HAIR_SHAMPOO: [`แชมพู`, `Shampoo`],
    HAIR_DRYSHAMPOO: [`ดรายแชมพู`, `Dry Shampoo`],
    TREATMENT: [`ทรีทเม้นท์`, `Treatment`],
    HAIR_HAIROIL: [`ออยล์บำรุงเส้นผม`, `Hair Oil`],
    HAIR_MASK: [`มาส์กบำรุงผม`, `Hair Masks`],
    HAIR_LOSS_TREATMENT: [`ทรีทเม้นท์สำหรับผมร่วง`, `Hair Loss & Treatment`],
    HAIR_SERUM: [`เซรั่มบำรุงเส้นผม`, `Hair Serum`],
    HAIR_COLOR_TECH: [`สีผมและอุปกรณ์`, `Color & Technique`],
    HAIR_COLOR: [`ผลิตภัณฑ์เปลี่ยนสีผม`, `Hair Color`],
    HAIR_TECH: [`อุปกรณ์จัดแต่งทรงผม`, `Hair Technique`],
    BATH_SHOWER: [`ผลิตภัณฑ์อาบน้ำ`, `Bath & Shower`],
    BATHBODY_BODY_WASH: [`ครีมและสบู่อาบน้ำ`, `Body Wash`],
    BATHBODY_SOAK: [`บาธโซค`, `Bath Soak`],
    BATHBODY_SCRUB: [`สครับผิวกาย`, `Body Scrub & Exfoliator`],
    BATHBODY_SHOWER_SET: [`เซ็ตผลิตภัณฑ์อาบน้ำ`, `Bath & Shower Sets`],
    BATHBODY_BODY_POWDER: [`แป้งทาตัว`, `Body Powder`],
    BATHBODY_HAND_WASH: [`สบู่ล้างมือและเจลล้างมือ`, `Hand Wash & Sanitary Hand Gel`],
    // MOISTURISER: [`มอยเจอร์ไรเซอร์`,`Moisturiser`],
    BATHBODY_HAND_CREAM: [`ครีมบำรุงมือ`, `Hand Cream`],
    BATHBODY_BODY: [`มอยเจอร์ไรเซอร์สำหรับผิวกาย`, `Body`],
    BATHBODY_FOOT_CREAM: [`ครีมบำรุงเท้า`, `Foot Cream`],
    // SUN_CARE: [`ผลิตภัณฑ์ปกป้องผิวจากแสงแดด`,`Sun Care`],
    SUN_PROTECT: [`ครีมกันแดด`, `Sun Protection`],
    // AFTER_SUN: [`ผลิตภัณฑ์บำรุงผิวหลังออกแดด`,`After Sun Care`],
    SELF_TANNER: [`ผลิตภัณฑ์ทำผิวแทน`, `Self Tanner`],
    GROOMING: [`ผลิตภัณฑ์จัดแต่ง`, `Grooming`],
    DEODORANT: [`ผลิตภัณฑ์ระงับกลิ่นกาย`, `Deodorant`],
    BATHBODY_MASK_TREAT: [`มาส์กและทรีทเม้นท์`, `Mask & Treatments`],
    BATHBODY_CELLULITE: [`ทรีทเม้นท์ลดเลือนเซลลูไลท์และรอยแตกลาย`, `Cellulite & Firming & Stretch Mark`],
    BATHBODY_BODY_MASK: [`มาส์กบำรุงผิวกาย`, `Body Mask`],
    BATHBODY_ORAL_CARE: [`ผลิตภัณฑ์ดูแลช่องปาก`, `Oral care`],
    BATHBODY_TOOTHPASTE: [`ยาสีฟัน`, `Toothpaste`],
    BATHBODY_TOOTHBRUSH: [`แปรงสีฟัน`, `Toothbrush`],
    BATHBODY_MOUTH_WASH: [`น้ำยาบ้วนปาก`, `Mouth Wash`],
    BATHBODY_MOUTH_SPRAY: [`สเปรย์ดับกลิ่นปาก`, `Mouth Spray`],
    BATHBODY_OTHER_CARE: [`ผลิตภัณฑ์ดูแลช่องปากและอุปกรณ์อื่นๆ`, `Other care & Accessory`],
    BATHBODY_HAIR: [`ผลิตภัณฑ์กำจัดขนและฟอกสีผม`, `Hair Removal & Bleaching`],
    BATHBODY_HAIR_REMOVAL: [`ผลิตภัณฑ์กำจัดขน`, `Hair Removal`],
    BATHBODY_HAIR_BLEACHING: [`ผลิตภัณฑ์ฟอกสีผม`, `Hair Bleaching`],
    FRAGRANCE_WOMEN: [`สำหรับผู้หญิง`, `Women`],
    PERFUME: [`น้ำหอม`, `Perfume`],
    CREAM_LOTION: [`ครีมและโลชั่น`, `Cream & Lotion`],
    // BATH_SHOWER: [`ผลิตภัณฑ์อาบน้ำ`,`Bath & Shower`],
    // DEODORANT: [`ผลิตภัณฑ์ระงับกลิ่นกาย`,`Deodorant`],
    FRAGRANCE_MEN: [`สำหรับผู้ชาย`, `Men`],
    // PERFUME: [`น้ำหอม`,`Perfume`],
    // CREAM_LOTION: [`ครีมและโลชั่น`,`Cream & Lotion`],
    // BATH_SHOWER: [`ผลิตภัณฑ์อาบน้ำ`,`Bath & Shower`],
    // DEODORANT: [`ผลิตภัณฑ์ระงับกลิ่นกาย`,`Deodorant`],
    AFTER_SHAVE: [`ผลิตภัณฑ์หลังการโกนหนวด`, `After Shave`],
    FRAGRANCE_HOME: [`เครื่องหอมในบ้าน`, `Home Scent`],
    FRAGRANCE_CANDLE: [`เทียนหอม`, `Candle`],
    FRAGRANCE_AROMATIC_OIL_HUMIDIFIER: [`เครื่องน้ำมันหอมระเหย`, `Aromatic Oil/Humidifier`],
    FRAGRANCE_DIFFUSER: [`อุปกรณ์จุดน้ำมันหอม แผ่นน้ำหอม ก้านหอม`, `Diffuser`],
    FRAGRANCE_ROOM_FARBIC_SPRAY: [`สเปรย์ฉีดหมอน, สเปรย์ปรับอากาศ`, `Room/Fabic Spray`],
    FRAGRANCE_HAND_SANITIZER: [`สเปรย์แอลกอฮอล์`, `Perfume Hand Sanitizer`],
    FRAGRANCE_SACHET: [`ถุงหอม`, `Perfume Sachet`],
    FRAGRANCE_PREMIUM: [`น้ำหอมพรีเมี่ยม`, `Premium Perfume`],
    FRAGRANCE_INDIE: [`น้ำหอม`, `Perfume`],
    SUPP_BEAUTY: [`ดูแลความสวยความงาม`, `Beauty Concern`],
    SUPP_SKIN: [`อาหารเสริมและวิตามินบำรุงผิว`, `Skin`],
    SUPP_HAIR: [`อาหารเสริมและวิตามินบำรุงผม`, `Hair`],
    SUPP_NAIL: [`อาหารเสริมและวิตามินบำรุงเล็บ`, `Nail`],
    SUPP_WEIGHT: [`อาหารเสริมลดน้ำหนัก`, `Weight Control`],
    SUPP_WOMEN: [`สำหรับผู้หญิง`, `Women Concern`],
    SUPP_MEN: [`สำหรับผู้ชาย`, `Men Concern`],
    SUPP_WELLNESS: [`ดูแลสุขภาพ`, `Wellness`],
    SUPP_EYES_BOOST: [`อาหารเสริมและวิตามินบำรุงสายตา`, `Eyes Boost`],
    SUPP_BRAIN_BOOST: [`อาหารเสริมและวิตามินบำรุงสมอง`, `Brain Boost`],
    SUPP_JOINT_BONE: [`อาหารเสริมและวิตามินบำรุงกระดูกและข้อ`, `Joint & Bone`],
    SUPP_HEART: [`อาหารเสริมและวิตามินบำรุงหัวใจ`, `Heart`],
    SUPP_STRESS: [`อาหารเสริมและวิตามินผ่อนคลายความเครียด`, `Stress`],
    SUPP_COLD_ALLERGY: [`อาหารเสริมและวิตามินป้องกันหวัดและภูมิแพ้`, `Cold & Allergy`],
    MEN_SKINCARE: [`สกินแคร์`, `Skincare`],
    MEN_ACNE: [`รักษาสิว`, `Acne & Pore`],
    MEN_TONER: [`โทนเนอร์`, `Toner & Cleanser`],
    MEN_MASK: [`มาส์กและทรีทเม้นท์`, `Masks & Treatment`],
    MEN_EXFOLIATOR: [`ผลิตภัณฑ์ผลัดเซลล์ผิว`, `Exfoliator`],
    // MOISTURISER: [`มอยเจอร์ไรเซอร์`,`Moisturiser`],
    // GROOMING: [`ผลิตภัณฑ์จัดแต่ง`,`Grooming`],
    // DEODORANT: [`ผลิตภัณฑ์ระงับกลิ่นกาย`,`Deodorant`],
    MEN_SHAVING: [`ผลิตภัณฑ์สำหรับโกนหนวด`, `Shaving`],
    // BATH_SHOWER: [`ผลิตภัณฑ์อาบน้ำ`,`Bath & Shower`],
    // SUN_CARE: [`ผลิตภัณฑ์ปกป้องผิวจากแสงแดด`,`Sun Care`],
    // FACE_SUNSCREEN: [`ครีมกันแดดสำหรับผิวหน้า`,`Face Sunscreen`],
    // SUN_PROTECT: [`ครีมกันแดด`,`Sun Protection`],
    // AFTER_SUN: [`ผลิตภัณฑ์บำรุงผิวหลังออกแดด`,`After Sun Care`],
    // SELF_TANNER: [`ผลิตภัณฑ์ทำผิวแทน`,`Self Tanner`],
    HAIR_CARE: [`ผลิตภัณฑ์ดูแลเส้นผม`, `Hair Care`],
    // HAIR_STYLING: [`จัดแต่งทรงผม`,`Hair Styling`],
    HAIR_TREATMENT: [`ผลิตภัณฑ์บำรุงผม`, `Hair Treatments`],
    MEN_PLEASURE: [`ผลิตภัณฑ์เสริมรัก`, `Personal Pleasure`],
    MEN_CONDOM: [`ถุงยางอนามัย`, `Condom`],
    MEN_LUBRICANT_GEL: [`เจลหล่อลื่น`, `Lubricant Gel`],
    MEN_INTIMATE_WASH: [`ผลิตภัณฑ์ทำความสะอาดจุดซ่อนเร้นสำหรับผู้ชาย`, `Intimate Wash`],
    PERSONAL_INTIMATE: [`อุปกรณ์สำหรับจุดซ่อนเร้น`, `Intimate Wear`],
    PERSONAL_SANITARY: [`ผ้าอนามัยและแผ่นอนามัย`, `Sanitary Napkin & Panty Liner`],
    PERSONAL_FEMININE: [`ผลิตภัณฑ์ทำความสะอาดจุดซ่อนเร้นสำหรับผู้หญิง`, `Feminine Wash`],
    PERSONAL_PAPER_UNDERWEAR: [`กางเกงในกระดาษ`, `Paper Underwear`],
    PERSONAL_NIPPLE: [`สติกเกอร์แปะหัวนม`, `Nipple Sticker`],
    OTHER: [`อื่นๆ`, `Other`],
    PERSONAL_EYECARE: [`ดูแลดวงตา`, `Eye Care `],
    PERSONAL_CONTACT_LEN: [`คอนแทคเลนส์`, `Contact Len`],
    PERSONAL_EYE_SOLUTION: [`น้ำยาหยอดตาและน้ำยาคอนแทคเลนส์`, `Eye Solution & Contact Len Tool`],
    PERSONAL_HERB_CARE: [`สปาและสมุนไพร`, `Spa & Herb Care`],
    PERSONAL_BALM_INHALER: [`ยาหม่องและยาดม`, `Balm & Inhaler`],
    PERSONAL_MASK_PLASTER: [`หน้ากากอนามัยและพลาสเตอร์`, `Protective Mask & Plaster`],
    PERSONAL_MOSQUITO: [`ผลิตภัณฑ์ป้องกันยุง`, `Mosquito Repellent`],
    PERSONAL_MEDICATED_SPABALL: [`พลาสเตอร์ยาและลูกประคบ`, `Medicated Plaster & Spa Ball`],
    ACC_EYE: [`ตา`, `Eyes`],
    ACC_FALSE_EYELASH: [`ขนตาปลอม`, `False Eyelash`],
    ACC_EYELASH_GLUE: [`กาวติดขนตาปลอม`, `Eyelash Glue`],
    ACC_DOUBLE_EYELID: [`ตาสองชั้น`, `Double Eyelid`],
    ACC_NAILCOLOR: [`เล็บ`, `Nail Color`],
    ACC_NAILPOLISH: [`น้ำยาทาเล็บ`, `Nail Polish`],
    ACC_BASE_TOPCOAT: [`น้ำยาเคลือบเล็บ`, `Base & Top Coat`],
    ACC_TREATMENT: [`ผลิตภัณฑ์บำรุงเล็บ`, `Nail Treatments`],
    ACC_POLISH_REMOVER: [`น้ำยาล้างเล็บ`, `Nail Polish Remover`],
    ACC_ART: [`ผลิตภัณฑ์ตกแต่งเล็บ`, `Nail Art`],
    ACC_SET: [`เซ็ตอุปกรณ์ดูแลเล็บ`, `Nail Sets`],
    ACC_BATH_TOOL: [`อุปกรณ์อาบน้ำ`, `Bath & Shower Tools`],
    ACC_BAG_ORGANISER: [`กระเป๋าเก็บเครื่องสำอางค์`, `Bag & Organiser`],
    ACC_PALETTE_ORGANISER: [`ที่จัดเก็บพาเลท`, `Palette Organiser`],
    ACC_CONTAINER: [`ที่ใส่เครื่องสำอาง`, `Container`],
    ACC_MAKEUP_BAG: [`กระเป๋าเครื่องสำอางค์`, `Makeup Bag`],
    ACC_PROFESSIONAL_CASE: [`กล่องเครื่องสำอาง`, `Professional Case`],
    ACC_MANICURE: [`ผลิตภัณฑ์ดูแลเล็บมือและเล็บเท้า`, `Manicure & Pedicure`],
    ACC_SCISSORS: [`กรรไกร`, `Scissors`],
    ACC_TOE_SEPARATOR: [`ที่คั่นนิ้วเท้า`, `Toe Separators`],
    ACC_PEDICURE_TOOL: [`อุปกรณ์ดูแลเล็บเท้า`, `Pedicure Tools`],
    ACC_MANICURE_SET: [`เซ็ตอุปกรณ์ดูแลเล็บมือและเล็บเท้า`, `Manicure & Pedicure Sets`],
    ACC_NAILCLIPPER: [`กรรไกรตัดเล็บ`, `Nail Clippers`],
    ACC_NAIL_FILES: [`ตะไบเล็บและที่ขัดเล็บ`, `Nail Files & Buffers`],
    ACC_BRUSH: [`แปรงแต่งหน้า`, `Brushes`],
    ACC_MULTI_BRUSH: [`แปรงอเนกประสงค์`, `Multipurpose Brushes`],
    ACC_FACE_BRUSH: [`แปรงแต่งหน้า`, `Face Brushes`],
    ACC_EYE_BRUSH: [`แปรงแต่งตา`, `Eye Brushes`],
    ACC_LIP_BRUSH: [`พู่กันทาปาก`, `Lip Brushes`],
    ACC_BRUSH_CLEANER: [`ผลิตภัณฑ์ทำความสะอาดแปรง`, `Brush Cleaners`],
    ACC_BRUSH_SET: [`เซ็ตแปรงแต่งหน้า`, `Brush Sets`],
    ACC_MAKEUP_ACCESS: [`อุปกรณ์แต่งหน้า`, `Makeup Accessories`],
    ACC_PENCIL_SHARP: [`กบเหลาดินสอ`, `Pencil Sharpeners`],
    ACC_MIRROR: [`กระจก`, `Mirrors`],
    ACC_EYELASH_CURLER: [`ที่ดัดขนตา`, `Eyelash Curlers`],
    ACC_TWEEZER: [`ตกแต่งคิ้ว`, `Tweezers & Brows`],
    ACC_SPONGE: [`ฟองน้ำแต่งหน้า`, `Sponges`],
    ACC_POWDER_PUFF: [`พัฟทาแป้ง`, `Powder Puffs`],
    ACC_HAIRTOOL: [`อุปกรณ์สำหรับเส้นผม`, `Hair Tools`],
    ACC_HAIR_ACCESSORY: [`เครื่องประดับผม`, `Hair Accessories`],
    ACC_BRUSH_COMB: [`แปรงและหวี`, `Brushes & Combs`],
    ACC_HAIR_ELECTRONIC: [`อุปกรณ์ทำผม`, `Hair Electronic Devices`],
    ACC_OTHER_ACCESSORY: [`อุปกรณ์และของใช้อื่นๆ`, `Other Accessories & Devices`],
    ACC_OTHER_TOOL: [`ของใช้อื่นๆ`, `Other Tool`],
    ACC_OTHER_DEVICE: [`อุปกรณ์อื่นๆ`, `Other Device`],
    DERMA_SET: [`ชุดเวชสำอางค์`, `Derma Set`],
    DERMA_BODY_CARE: [`ดูแลผิวกาย`, `Body Care`],
    WAY_TO_SHOP: [`ช้อปออนไลน์`, `Beautrium Online`],
    CUSTOMER_SERVICE: [`ลูกค้าสัมพันธ์`, `Customer Services`],
    SHOPPING_GUIDE: [`วิธีการสั่งซื้อและชำระเงิน`, `Shopping & Payment Guide`],
    ORDER_PAYMENT: [`วิธีการชำระเงิน`, `Order & Payment`],
    EXCHANGE_RETURN: [`นโยบายการเปลี่ยนและคืนสินค้า`, `Exchange & Return Policy`],
    // TRACKING_ORDER: [`ติดตามสินค้า`,`Order Tracking`],
    // FAQ: [`คำถามที่พบบ่อย`,`FAQs`],
    NEWS_EVENT: [`ข่าวและกิจกรรม`, `Beautrium News & Events`],
    // ABOUT_US: [`เกี่ยวกับเรา`,`About Beautrium`],
    CONTACT_US: [`ติดต่อเรา`, `Contact Us`],
    PARTNER: [`สนใจร่วมกับเรา`, `Partner With Us`],
    STORES: [`สาขาและที่ตั้ง`, `Our Stores Location`],
    OPENING_TIME: [`เวลาเปิดปิด`, `Opening Time`],
    FOLLOW_US: [`ติดตามข่าวสารของเราได้ที่นี่: `, `Follow us on: `],
    TERMS_OF_USE: [`ข้อตกลงและเงื่อนไข`, `Terms of Use`],
    PRIVACY_POLICY: [`นโยบายความเป็นส่วนตัว`, `Privacy Policy`],
    SIGNUP_FOR_EMAIL: [`ลงทะเบียนเพื่อรับข่าวสารและโปรโมชั่นจากเรา`, `Signup for Beautrium emails / Join our mailing list for latest updates!`],
    SITE_MAP: [`แผนผังเว็ปไซต์`, `Site Map`],
    VIEW_CART: [`ดูรถเข็นสินค้า`, `View Cart`],
    // LOGIN: [`เข้าสู่ระบบ`,`Login`],
    EMAIL: [`อีเมลล์`, `Email`],
    PASSWORD: [`รหัสผ่าน`, `Password`],
    REMEMBER_ME: [`จดจำรหัสผ่าน`, `Remember Me`],
    FORGOT_PASS: [`ลืมรหัสผ่าน`, `Forgot Password`],
    LOGIN_FB: [`เข้าสู่ระบบด้วย Facebook`, `Log in with facebook`],
    NO_ACCOUNT: [`ยังไม่ได้เป็นสมาชิก Beautrium?`, `Don't have an account?`],
    // SIGN_UP: [`สมัครสมาชิก`,`Sign up`],
    FIRST_NAME: [`ชื่อ`, `First Name`],
    LAST_NAME: [`นามสกุล`, `Last Name`],
    CREATE_ACCOUNT: [`สร้างบัญชีสมาชิก`, `Create an account`],
    SIGNUP_FB: [`สมัครสมาชิกด้วยบัญชี Facebook`, `Sign up with facebook`],
    HAVE_ACCOUNT: [`เป็นสมาชิก Beautrium อยู่แล้ว?`, `Already have an account?`],
    PROCEED_CHECKOUT: [`เข้าสู่ขั้นตอนการชำระเงิน`, `Proceed to Checkout`],
    // VIEW_CART: [`ดูรถเข็นสินค้า`,`View Cart`],
    CONTINUE_SHOPPING: [`เลือกซื้อสินค้าต่อ`, `Continue Shopping`],
    // SHOPPING_CART: [`รถเข็นสินค้า`,`Shopping Cart`],
    CART_SHIPPING: [`การจัดส่งสินค้า`, `Shipping`],
    CART_REVIEW_PAYMENT: [`ตรวจสอบคำสั่งซื้อและชำระเงิน`, `Review & Payment`],
    CART_PRODUCT: [`สินค้าในรถเข็น`, `Product`],
    CART_PRICE: [`ราคาต่อหน่วย`, `Price`],
    CART_QTY: [`จำนวน`, `Quantity`],
    CART_Total: [`รวม`, `Total`],
    CART_REMOVE: [`ลบรายการ`, `Remove`],
    CART_SUMMARY: [`สรุปยอดสั่งซื้อทั้งหมด`, `Summary`],
    CART_SUBTOTAL: [`ยอดรวมเบื้องต้น`, `Subtotal`],
    CART_DELIVERY_COST: [`ค่าจัดส่ง`, `Delivery Cost`],
    CART_TOTAL_COST: [`รวมทั้งหมด`, `Total Cost`],
    CART_PROMOCODE: [`รหัสส่วนลด`, `Discount Codes`],
    CART_PROMOCODE_INSIDE: [`ใส่รหัสส่วนลด (ถ้ามี)`, `Enter your coupon code if you have one.`],
    CART_PROMOCODE_APPLY: [`ยืนยันรหัส`, `Apply`],
    CART_BACK_TO_CART: [`กลับไปหน้ารถเข็นสินค้า`, `Back to cart`],
    ADDRESS: [`ที่อยู่`, `BILLING ADDRESS`],
    ADD_NEW_ADDRESS: [`เพิ่มที่อยู่ใหม่`, `Add a new address`],
    ADDRESS_FIRST_NAME: [`ชื่อ`, `First Name`],
    ADDRESS_LAST_NAME: [`นามสกุล`, `Last Name`],
    ADDRESS_ADDRESS: [`ที่อยู่`, `Address`],
    ADDRESS_DISTRICT: [`แขวง/ตำบล`, `District`],
    ADDRESS_CITY: [`เขต/อำเภอ`, `City`],
    ADDRESS_PROVINCE: [`จังหวัด`, `Steate/Province`],
    ADDRESS_POSTAL_CODE: [`รหัสไปรษณีย์`, `Zip/Postal Code`],
    ADDRESS_TELEPHONE: [`เบอร์โทรศัพท์`, `Telephone`],
    ADDRESS_SAVEADDRESS_CART: [`บันทึกที่อยู่ไว้ใช้ครั้งหน้า`, `Save Address `],
    ADDRESS_CANCEL: [`ยกเลิกการเพิ่มที่อยู่`, `Cancel`],
    SHIPPING_METHOD: [`วิธีการส่งสินค้า`, `Shipping Method`],
    SHIPPING_SELECT_METHOD: [`กรุณาเลือกวิธีการส่งสินค้า`, `Select Shipping Method`],
    SHIPPING_FREE: [`ฟรี`, `Free`],
    PAYMENT_DELIVERY_INFO: [`รายละเอียดการจัดส่ง`, `Delivery Info`],
    PAYMENT_METHOD: [`วิธีการชำระเงิน`, `Choose your payment method`],
    // ADDRESS_FIRST_NAME: [`ชื่อ`,`First Name`],
    // ADDRESS_LAST_NAME: [`นามสกุล`,`Last Name`],
    ACCOUNT_INFO_EMAIL: [`อีเมลล์`, `Email Address`],
    ACCOUNT_INFO_BIRTH: [`วัน เดือน ปีเกิด`, `Birthdate`],
    // ADDRESS_TELEPHONE: [`เบอร์โทรศัพท์`,`Telephone`],
    ACCOUNT_FACE_SHAPE: [`ลักษณะใบหน้า`, `Face Shape`],
    ACCOUNT_FACE_Tone: [`สีของผิวหน้า`, `Face Tone`],
    ACCOUNT_FACE_Type: [`ประเภทผิวหน้า`, `Face Type`],
    ACCOUNT_FACE_Problem: [`ปัญหาผิวหน้า`, `Face Problems`],
    ACCOUNT_BODY_SHAPE: [`ลักษณะรูปร่าง`, `Body Shape`],
    ACCOUNT_BODY_Tone: [`สีผิว`, `Body Tone`],
    ACCOUNT_BODY_Type: [`ประเภทผิว`, `Body Type`],
    ACCOUNT_BODY_Problem: [`ปัญหาผิว`, `Body Problems`],
    ACCOUNT_HAIR_Type: [`ลักษณะเส้นผม`, `Hair Type`],
    ACCOUNT_HAIR_Problem: [`ปัญหาเส้นผม`, `Hair Problems`],
    ACCOUNT_UPDATE_PROFILE: [`อัพเดตข้อมูลส่วนตัว`, `Update my profile`],
    ACCOUNT_CHANGE_PASSWORD: [`เปลี่ยนแปลงรหัสผ่าน`, `Change Password`],
    ACCOUNT_CURRENT_PASSWORD: [`รหัสผ่านปัจจุบัน`, `Current Password`],
    ACCOUNT_NEW_PASSWORD: [`รหัสผ่านใหม่`, `New Password`],
    ACCOUNT_CONFIRM_NEW_PASSWORD: [`ยืนยันรหัสผ่านใหม่`, `Confirm New Password`],
    ACCOUNT_UPDATE_PASSWORD: [`อัพเดตรหัสผ่าน`, `Update password`],
    ADDRESS_BOOK_DEFAULT: [`ตั้งเป็นที่อยู่หลัก`, `Set as Default`],
    ADDRESS_BOOK_EDIT: [`แก้ไขที่อยู่`, `Edit`],
    ADDRESS_BOOK_REMOVE_MESSAGE: [`ลบที่อยู่`, `Remove`],
    // ADDRESS_BOOK_REMOVE_MESSAGE: [`คุณยืนยันที่จะลบที่อยู่นี้ใช่หรือไม่`,`Are you sure to delete Address`],
    ADDRESS_BOOK_REMOVE_CANCEL: [`ยกเลิก`, `Cancel`],
    ADDRESS_BOOK_REMOVE_OK: [`ยืนยัน`, `OK`],
    ADDRESS_BOOK_DELETED: [`ลบที่ี่อยู่`, `Address Deleted`],
    ADDRESS_BOOK_DELETED_MESSAGE: [`ที่อยู่ของคุณถูกลบเรียบร้อยแล้ว`, `The address is successfully deleted.`],
    ADDRESS_BOOK_DELETED_FAIL_MESSAGE: [`ไม่สามารถลบที่อยู่ได้สำเร็จ`, `Address is failed to delete.`],
    ADDRESS_BOOK_ADD_NEW_ADDRESS: [`เพิ่มที่อยู่ใหม่`, `Add a new address`],
    ADDRESS_BOOK_CREATE: [`บันทึกที่อยู่`, `Address Created`],
    ADDRESS_BOOK_CREATE_MESSAGE: [`ที่ี่อยู่ของคุณถูกบันทึกเรียบร้อยแล้ว`, `New Address is successfully created.`],
    MY_ORDER_DATE: [`วันที่สั่งซื้อ`, `Order Date`],
    MY_ORDER_ORDERNUMBER: [`คำสั่งซื้อเลขที่`, `Order Number`],
    MY_ORDER_TOTAL: [`จำนวนเงิน`, `Total Amount`],
    MY_ORDER_STATUS: [`สถานะการสั่งซื้อ`, `Order Status`],
    MY_ORDER_VIEW_DETAIL: [`ดูรายละเอียด`, `View Details`],
    ORDER_STATUS_PLACED: [`รอการชำระเงิน`, `Placed`],
    ORDER_STATUS_PROCESSING: [`ตรวจสอบยอดเงิน`, `Processing`],
    ORDER_STATUS_ORDER_PREPARE: [`เตรียมส่งสินค้า`, `Order Preparing`],
    ORDER_STATUS_PACKING: [`แพ็คสินค้าแล้ว`, `Packing`],
    ORDER_STATUS_DELIVER: [`จัดส่งสินค้าแล้ว`, `Delivered`],
    ORDER_STATUS_CANCELL: [`ยกเลิกแล้ว/หมดอายุ`, `Cancelled`],
    PRODUCT_DISCLAIMER: [`* บิวเทรี่ยมไม่ขอรับผิดชอบใด ๆ ที่เกี่ยวกับความถูกต้องสมบูรณ์ของข้อมูลผลิตภัณฑ์บนเว็บไซต์นี้ ซึ่งได้มาโดยบุคคลที่สาม (ไม่ว่าจะเป็น จากแบรนด์หรือการรีวิวของลูกค้า) หากลูกค้าอยากทราบข้อเท็จจริงเกี่ยวกับผลิตภัณฑ์ กรุณาติดต่อโดยตรงกับทางแบรนด์ค่ะ`, `* Beautrium disclaims all accuracy, completeness or any other aspects of any product claims or descriptions on this website which have been provided to us by third parties (e.g. the relevant brand owners or customers reviews). Customers and users who wish to rely upon such product claims, descriptions or customer reviews should consult directly with such third parties.`],
    PARTNER_DETAIL: [`สนใจร่วมเป็นพาร์ทเนอร์กับเรา`, `Interested to be partner with us?`],
    PARTNER_DETAIL_2: [`ส่งรายละเอียดของท่านมายังอีเมลล์ตามด้านล่างนี้ได้เลยค่ะ เราจะติดต่อกลับโดยเร็วที่สุดค่ะ`, `Submit detail to below email and we will contact you soon.`],
    ADD_TO_CART: [`หยิบใส่รถเข็น`, `Add to Cart`],
    SOLD_OUT: [`สินค้าหมด`, `Sold Out`],
}